import { ReactNode } from 'react'

const HIGHLIGHTS = [
  {
    n: 1,
    title: 'Purchase → Repack → Sell, one entry each',
    text: 'Supplier bills route every item to repacking or direct sale; stock updates the moment you submit.',
  },
  {
    n: 2,
    title: 'FEFO billing with credit ledgers',
    text: 'Soonest-expiring batches sell first, and every credit invoice lands in the store ledger automatically.',
  },
  {
    n: 3,
    title: 'Route collections & store reliability',
    text: 'Track overdue credit by route, grade stores A/B/C, and export the day straight to Tally.',
  },
]

function Illustration() {
  return (
    <svg viewBox="0 0 520 320" className="w-full max-w-[520px] h-auto" role="img" aria-label="Bulk spice sacks repacked into retail packets and delivered by van to stores on a route">
      <defs>
        <linearGradient id="sackFill" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#E9C889" />
          <stop offset="1" stopColor="#C77D1F" />
        </linearGradient>
        <linearGradient id="bagFill" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#8FAE8E" />
          <stop offset="1" stopColor="#3C7A4F" />
        </linearGradient>
      </defs>
      <circle cx="250" cy="165" r="150" fill="#ffffff" opacity="0.05" />
      <circle cx="250" cy="165" r="105" fill="#ffffff" opacity="0.04" />
      <path d="M395 210 C 380 150, 330 140, 320 110 S 380 70, 415 88 S 470 150, 495 130" fill="none" stroke="#E9C889" strokeWidth="2" strokeDasharray="6 6" opacity="0.75" />
      {[{ x: 320, y: 110 }, { x: 415, y: 88 }, { x: 495, y: 130 }].map((p) => (
        <g key={`${p.x}-${p.y}`} transform={`translate(${p.x} ${p.y})`}>
          <path d="M0 -30 C -12 -30 -18 -20 -18 -12 C -18 -2 0 12 0 12 C 0 12 18 -2 18 -12 C 18 -20 12 -30 0 -30 Z" fill="#C77D1F" />
          <rect x="-8" y="-20" width="16" height="11" rx="1.5" fill="#F6F5F0" />
          <path d="M-9 -20 L0 -26 L9 -20 Z" fill="#F6F5F0" />
          <rect x="-2.5" y="-15" width="5" height="6" fill="#C77D1F" />
        </g>
      ))}
      <rect x="28" y="272" width="470" height="6" rx="3" fill="#ffffff" opacity="0.14" />
      <g transform="translate(62 160)">
        <ellipse cx="46" cy="6" rx="22" ry="7" fill="#8A5711" />
        <rect x="0" y="8" width="92" height="104" rx="22" fill="url(#sackFill)" />
        <rect x="14" y="52" width="64" height="22" rx="4" fill="#F6F5F0" opacity="0.92" />
        <text x="46" y="67" textAnchor="middle" fontSize="9" fontWeight="700" fill="#1F4B44" fontFamily="Segoe UI, Arial, sans-serif">CARDAMOM</text>
      </g>
      <g transform="translate(150 190)">
        <ellipse cx="38" cy="6" rx="18" ry="6" fill="#8A5711" />
        <rect x="0" y="8" width="76" height="74" rx="18" fill="url(#sackFill)" />
        <rect x="10" y="38" width="56" height="20" rx="4" fill="#F6F5F0" opacity="0.92" />
        <text x="38" y="52" textAnchor="middle" fontSize="8.5" fontWeight="700" fill="#1F4B44" fontFamily="Segoe UI, Arial, sans-serif">TOOR DAL</text>
      </g>
      <g transform="translate(118 132)">
        <rect x="0" y="0" width="58" height="46" rx="10" fill="url(#bagFill)" />
        <rect x="8" y="16" width="42" height="16" rx="3" fill="#F6F5F0" opacity="0.92" />
        <text x="29" y="27" textAnchor="middle" fontSize="7.5" fontWeight="700" fill="#1F4B44" fontFamily="Segoe UI, Arial, sans-serif">PEPPER</text>
      </g>
      {[{ x: 236, label: '10 g' }, { x: 268, label: '200 g' }, { x: 300, label: '1 kg' }].map((p) => (
        <g key={p.label} transform={`translate(${p.x} 228)`}>
          <rect x="0" y="0" width="28" height="44" rx="4" fill="#F6F5F0" />
          <rect x="0" y="0" width="28" height="9" rx="4" fill="#C77D1F" />
          <rect x="0" y="6" width="28" height="4" fill="#C77D1F" />
          <rect x="6" y="18" width="16" height="12" rx="2" fill="#E8EFEC" />
          <text x="14" y="39" textAnchor="middle" fontSize="7" fontWeight="700" fill="#1F4B44" fontFamily="Segoe UI, Arial, sans-serif">{p.label}</text>
        </g>
      ))}
      <path d="M212 246 L226 246" stroke="#E9C889" strokeWidth="2" strokeLinecap="round" />
      <path d="M222 242 L227 246 L222 250" fill="none" stroke="#E9C889" strokeWidth="2" strokeLinecap="round" />
      <g transform="translate(352 208)">
        <rect x="0" y="0" width="86" height="46" rx="6" fill="#F6F5F0" />
        <rect x="86" y="14" width="38" height="32" rx="6" fill="#F6F5F0" />
        <rect x="92" y="19" width="20" height="13" rx="2" fill="#1F4B44" opacity="0.55" />
        <rect x="0" y="28" width="124" height="5" fill="#C77D1F" />
        <text x="43" y="19" textAnchor="middle" fontSize="10" fontWeight="700" fill="#1F4B44" letterSpacing="1" fontFamily="Segoe UI, Arial, sans-serif">XORA</text>
        <circle cx="22" cy="48" r="9" fill="#1E2A28" stroke="#F6F5F0" strokeWidth="3" />
        <circle cx="102" cy="48" r="9" fill="#1E2A28" stroke="#F6F5F0" strokeWidth="3" />
      </g>
    </svg>
  )
}

export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-bg grid lg:grid-cols-[1.15fr_1fr]">
      <section
        className="hidden lg:flex flex-col justify-between text-white px-14 py-12"
        style={{
          background:
            'radial-gradient(circle at 20% 0%, rgba(255,255,255,0.08), transparent 45%), radial-gradient(circle at 100% 100%, rgba(199,125,31,0.25), transparent 40%), #1F4B44',
        }}
      >
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-[10px] bg-white/10 border border-white/20 flex items-center justify-center font-bold text-base">X</div>
          <div>
            <div className="text-[15px] font-bold leading-tight">Xora FMCG Ops</div>
            <div className="text-[11px] text-white/65">Distribution &amp; Billing Management</div>
          </div>
        </div>
        <div className="my-8">
          <Illustration />
          <h2 className="text-[26px] font-bold leading-tight mt-8 max-w-[520px] tracking-[-0.01em]">From bulk purchase to shop-shelf sale — one system, no double entry.</h2>
          <div className="mt-7 space-y-4 max-w-[520px]">
            {HIGHLIGHTS.map((h) => (
              <div key={h.n} className="flex gap-3">
                <div className="w-6 h-6 rounded-full bg-accent-500 text-[#22160a] text-[11px] font-bold flex items-center justify-center flex-shrink-0 mt-[1px]">{h.n}</div>
                <div>
                  <div className="text-[13.5px] font-semibold">{h.title}</div>
                  <div className="text-[12.5px] text-white/65 mt-[2px] leading-snug">{h.text}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="flex gap-6 text-[12px] text-white/60">
          <span><b className="text-white/90">Multi-company</b> SaaS</span>
          <span><b className="text-white/90">FEFO</b> batch billing</span>
          <span><b className="text-white/90">Tally</b> &amp; GST export</span>
        </div>
      </section>

      <section className="flex flex-col items-center justify-center px-6 py-10">
        <div className="lg:hidden flex items-center gap-3 mb-8">
          <div className="w-9 h-9 rounded-[8px] bg-primary-500 text-white flex items-center justify-center font-bold">X</div>
          <div>
            <div className="text-[14px] font-bold leading-tight">Xora FMCG Ops</div>
            <div className="text-[11px] text-ink-soft">Distribution &amp; Billing Management</div>
          </div>
        </div>
        {children}
        <p className="text-[12px] text-ink-soft mt-6">FMCG Operations Management System v2.0</p>
      </section>
    </div>
  )
}
